const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCamera(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.577 -5.51)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(2.577 5.51)",
    style: {
      fill: "rgba(0,0,0,.75)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1180",
    d: "M15.5 15.167a1.3 1.3 0 0 1-1.273 1.333H2.773A1.3 1.3 0 0 1 1.5 15.167V7.833A1.3 1.3 0 0 1 2.773 6.5h2.545l1.273-2h3.818l1.273 2h2.545A1.3 1.3 0 0 1 15.5 7.833z",
    transform: "translate(6.077 7.01)",
    style: {
      fill: "none",
      stroke: "current",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1181",
    d: "M17.109 16.054a2.554 2.554 0 1 1-2.555-2.554 2.554 2.554 0 0 1 2.555 2.554z",
    transform: "translate(.024 2.145)",
    style: {
      fill: "none",
      stroke: "current",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCamera);
export default __webpack_public_path__ + "static/media/btn-camera.2a51f66caaa2d4a9d2a5eb67663a0e4d.svg";
export { ForwardRef as ReactComponent };